import React from 'react';
import { HeroSection } from './components/HeroSection';
import { QuickTestimonials } from './components/QuickTestimonials';
import { IdentificationSection } from './components/IdentificationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ModulesSection } from './components/ModulesSection';
import { PreviewSection } from './components/PreviewSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-bg text-ink" data-id="element-0" data-mp="3ikqwhsrnks2k">
      <HeroSection data-id="element-1" data-mp="3ii4q3wgi0ilx" />
      <QuickTestimonials data-id="element-2" data-mp="3ml14tc2x3ukl" />
      <IdentificationSection data-id="element-3" data-mp="3mkhou0wtvg97" />
      <ProductPresentation data-id="element-4" data-mp="3mjg9vlcoy9m7" />
      <WhatYouLearn data-id="element-5" data-mp="3rcj6618urx63" />
      <ModulesSection data-id="element-6" data-mp="3rbzlwdvqcwow" />
      <PreviewSection data-id="element-7" data-mp="3rdkl4gszp3t3" />
      <BonusSection data-id="element-8" data-mp="3recedkz46pg7" />
      <TransformationSection data-id="element-9" data-mp="5yhupa6n3cr" />
      <OfferSection data-id="element-10" data-mp="682dxcgkib2" />
      <TestimonialsSection data-id="element-11" data-mp="5gel8p3rovc" />
      <GuaranteeSection data-id="element-12" data-mp="7sulgbavp5r" />
      <FAQSection data-id="element-13" data-mp="2zld4hgdhhrep" />
      <CostSection data-id="element-14" data-mp="2zlv32jnmchps" />
      <FinalCTA data-id="element-15" data-mp="2zmo557bmuj1l" />
      <Footer data-id="element-16" data-mp="2zn69yscd25l4" />
    </div>;
}